<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/>
<path style="fill:#D80027;" d="M256,0v256L74.98,437.02C121.307,483.346,185.307,512,256,512c141.384,0,256-114.616,256-256
	S256,0,256,0z"/>
<path style="fill:#0052B4;" d="M256,0C185.307,0,121.307,28.654,74.98,74.98C137.79,137.79,160.087,160.088,256,256h256
	C512,114.616,397.384,0,256,0z"/>
<g>
	<polygon style="fill:#FFDA44;" points="175.291,256 144.027,241.294 160.676,211.015 126.726,217.51 122.424,183.213 
		98.776,208.437 75.129,183.213 70.826,217.51 36.877,211.014 53.526,241.294 22.261,256 53.526,270.706 36.877,300.985 
		70.829,294.491 75.128,328.787 98.776,303.563 122.424,328.787 126.726,294.491 160.674,300.986 144.026,270.707 	"/>
	<polygon style="fill:#FFDA44;" points="68.273,100.174 78.677,114.717 95.722,109.318 85.104,123.706 95.508,138.249 
		78.542,132.598 67.925,146.985 68.058,129.105 51.093,123.453 68.141,118.054 	"/>
	<polygon style="fill:#FFDA44;" points="68.273,365.015 78.677,379.558 95.722,374.158 85.104,388.547 95.508,403.09 
		78.542,397.439 67.925,411.826 68.058,393.946 51.093,388.294 68.141,382.895 	"/>
	<polygon style="fill:#FFDA44;" points="216.666,232.595 206.263,247.138 189.217,241.737 199.835,256.126 189.431,270.67 
		206.397,265.018 217.015,279.405 216.881,261.526 233.846,255.874 216.799,250.475 	"/>
</g>
</svg>